module.exports = __webpack_public_path__ + "static/media/baywar.379e14d1.png";